import PropTypes from 'prop-types'
import React from 'react'

import { PROVIDER, FACILITY } from 'constants/constants'
import { Table } from 'ui/styled'
import rightway_star from 'assets/rightway_star.svg'
import EntityTypes from 'components/EntityTypes'

import useEntitiesTable from './useEntitiesTable'
import { RatingWrap, RatingIcon } from './styled'
import ActionButtons from './ActionButtons'

const EntitiesTable = ({
  entityType = false,
  filterValues = false,
  onSelect,
  addressUpdateLoading = false,
  employee_id
}) => {
  const { data } = useEntitiesTable(entityType, filterValues, employee_id)
  const { loading, entities, scrollLoading } = data

  const facilitiesColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'Facility Type',
      key: 'type',
      render: facility => (
        <EntityTypes
          entity={facility}
          length={2}
          sourceField="display_location_types"
        />
      )
    },
    {
      title: 'Actions',
      key: 'actions',
      render: facility => (
        <ActionButtons
          path="/facilities/"
          entity={facility}
          onSelect={onSelect}
          entityType={entityType}
        />
      )
    }
  ]

  const providersColumns = [
    {
      title: 'Name',
      dataIndex: 'full_name',
      key: 'name'
    },
    {
      title: 'Rating',
      key: 'rating',
      render: provider => (
        <RatingWrap>
          <RatingIcon src={rightway_star} alt="Star" />
          {provider?.rating}
        </RatingWrap>
      )
    },
    {
      title: 'Specialty',
      key: 'specialty',
      render: provider => (
        <EntityTypes
          entity={provider}
          length={2}
          sourceField="specialty_names"
        />
      )
    },
    {
      title: 'Actions',
      key: 'actions',
      render: provider => (
        <ActionButtons
          path="/providers/"
          entity={provider}
          onSelect={onSelect}
          entityType={entityType}
        />
      )
    }
  ]

  let columns = []
  if (entityType === PROVIDER) columns = providersColumns
  if (entityType === FACILITY) columns = facilitiesColumns

  const rowTestId = entityType === PROVIDER ? 'providerRow' : 'facilityRow'

  return (
    <Table
      mixCellTestId
      loading={{
        spinning: loading || scrollLoading || addressUpdateLoading,
        'data-test': 'entitiesTableSpinner'
      }}
      dataSource={entities}
      columns={columns}
      scroll={{ y: 400 }}
      padding="0"
      data-test="entitiesTable"
      onRow={() => ({ 'data-test': rowTestId })}
    />
  )
}

EntitiesTable.propTypes = {
  entityType: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  filterValues: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  onSelect: PropTypes.func.isRequired,
  addressUpdateLoading: PropTypes.bool,
  employee_id: PropTypes.string.isRequired
}

export default EntitiesTable
